module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg3MS43IDUwNi45YTMxLjkgMzEuOSAwIDAgMC05LjMtMjAuN2wtMjcxLjYtMjcxLjVhMzIgMzIgMCAwIDAtNDUuMiA0NS4yTDc2NS44IDQ4MCAxOTIgNDgwYTMyIDMyIDAgMCAwIDAgNjRoNTY4LjJsLTIxNC42IDIxNC42YTMyIDMyIDAgMSAwIDQ1LjIgNDUuMmwyNzEuNi0yNzEuNWEzMS45IDMxLjkgMCAwIDAgOS4zLTIwLjd2LTQuN3oiIGZpbGw9IiMwIiBwLWlkPSI4NzMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-right-outlined.svg
// module id = oLQ5
// module chunks = 75